import * as firebase from 'firebase/app'
import 'firebase/performance'
import { checkCompat } from './compatibility/index'
// import 'first-input-delay' TODO 有问题
import {initHack, hackLocalStorage, hackFetch} from './utils/hack'
import * as navigation from './record/navigation'
import * as api from './record/api'
import * as frame from './record/frame'
import * as action from './record/action'
import * as page from './record/page'
import {performanceInitializationPromise} from './utils/hack'
import routerBeforeChange from './utils/routerBeforeChange'
import runtime from "./utils/runtime";
import { removeTrailingSlash, addLeadingSlash, getRouteConfig } from './utils/path';
import logger from './logger'
import { startObserver } from './mutationObserver'
import storage from './utils/storage'
import { setUpTransport } from './transport'

let firebaseApp
let readyCallbacks = []

const firebaseReadyCallback = callback => {
  if (typeof callback !== 'function') {
    return false
  }

  if (!firebaseApp) {
    readyCallbacks.push(callback)
  } else {
    callback()
  }
}

function invokeCallbacks() {
  readyCallbacks.forEach(cb => {
    cb()
  })
  readyCallbacks = []
}

function processRouteNameMap(routeBase, routeNameMap = {}) {
  const nameMap = {}
  const base = removeTrailingSlash(routeBase)

  Object.keys(routeNameMap).forEach(key => {
    const value = routeNameMap[key]
    const k = addLeadingSlash(removeTrailingSlash(key))
    const p = addLeadingSlash(`${base}${k}`)
    nameMap[p] = value
  })

  return nameMap
}

function processRouteConfig(routeBase, routeConfig = {}) {
  const config = {}
  const base = removeTrailingSlash(routeBase)

  Object.keys(routeConfig).forEach(key => {
    const value = routeConfig[key].name || routeConfig[key]
    const k = addLeadingSlash(removeTrailingSlash(key))
    const p = addLeadingSlash(`${base}${k}`)
    config[p] = {
      ...routeConfig[key],
    }
  })

  return config
}

function mergeNameMapToConfig(nameMap, config) {
  Object.keys(nameMap).forEach(key => {
    if (!config[key]) {
      config[key] = {
        name: nameMap[key],
        firebase: {
          enabled: true,
        },
      }
    }
  })

  return config
}

function setRuntimeVars({
  config,
  env,
  pageMode,
  routeNameMap,
  routeBase,
  routeConfig,
  shouldLog,
  shouldReport,
  whiteApiDomain
}) {
  runtime.set('env', env)
  runtime.set('pageMode', pageMode)
  runtime.set('whiteApiDomain', whiteApiDomain)

  if (env !== 'prod') {
    runtime.set('shouldLog', shouldLog)
    runtime.set('shouldReport', shouldReport)
  }

  // const nameMap = processRouteNameMap(routeBase, routeNameMap)

  // runtime.set('routeNameMap', nameMap)

  const nameMap = processRouteNameMap(routeBase, routeNameMap)
  const configMap = processRouteConfig(routeBase, routeConfig)
  const routeConfigMap = mergeNameMapToConfig(nameMap, configMap);

  runtime.set('routeConfig', routeConfigMap);
}

function checkRequiredOptions({
  config,
  env,
  pageMode,
  routeNameMap,
  routeConfig,
}) {
  // if (config && env && pageMode && routeNameMap) {
  //   return true
  // }
  if (env && pageMode && (routeConfig || routeNameMap)) {
    if (!routeConfig && routeNameMap) {
      logger.error('[performance collect] routeNameMap 配置已废弃，请使用 routeConfig')
    }
    return true;
  }

  logger.error('[firebase] config, env, pageMode, routeConfig 必填！')
  return false
}

function checkWhiteApiDomainType({
  whiteApiDomain
}) {
  if (Array.isArray(whiteApiDomain)) {
    return true
  }

  logger.error('[firebase] whiteApiDomain 必须是数组！')
  return false
}

function removeDeprecatedData() {
  try {
    storage.clear({
      key: 'LOCAL_STORAGE_ACTION_3ef705fd'
    })
    storage.clear({
      key: 'LOCAL_STORAGE_FRAME_11a7e258',
    })
  } catch (error) {
    logger.error(error)
  }
}

const init = ({
    config,
    env,
    pageMode,
    routeNameMap,
    routeBase = '/',
    routeConfig,
    shouldLog = false,
    shouldReport = false,
    whiteApiDomain = []
}) => {
    if (!checkRequiredOptions({
        config,
        env,
        pageMode,
        routeNameMap,
        routeConfig,
      })
    ) {
      return false
    }

    if (!checkCompat(env)) {
      return false
    }

    if(!checkWhiteApiDomainType({whiteApiDomain})){
      return false
    }

    setRuntimeVars({
      config,
      env,
      pageMode,
      routeNameMap,
      routeConfig,
      routeBase,
      shouldLog,
      shouldReport,
      whiteApiDomain
    })

    removeDeprecatedData()

    hackLocalStorage()
    hackFetch()

    setUpTransport();

    if (config) {
      // hot reload会导致重复挂载
      if (!firebase.apps.length) {
        firebaseApp = firebase.initializeApp(config)
        invokeCallbacks()
      }
      initHack()
    }

    performanceInitializationPromise.then(() => {
      navigation.init()
      api.init()
      frame.init()
      action.init()
    })

    startObserver(page.observeCallback)

    // 路由变化时通知对应方法执行
    routerBeforeChange([
      () => page.whenRouterChange(),
      () => frame.whenRouterChange(),
      () => action.whenRouterChange(),
    ])
}

export default {
  init,
  recordPagePerformance: page.recordPagePerformance,
  getPageMode: page.getPageMode,
  writeFrameData: frame.writeFrameData,
  reportPageInteractive: () => {
    logger.error('此方法已废弃，请使用 recordPagePerformance 方法')
  },
  setDeviceLevel: (level) => {
    runtime.set('deviceLevel', level)
  },
  firebase,
  firebasePerformance: firebase.performance,
  firebaseReadyCallback
}
